/** 型別 - 所有權限 */
export enum PermissionType {
  EXPORT = 'export',
  REIMBURSEMENT = 'reimbursement',
  APPROVE = 'approve',
  EDIT = 'edit',
  VIEW = 'view'
}
